import React from 'react';
import { Input } from 'antd';
import { SearchOutlined } from '@ant-design/icons';

export interface ManagerSearchByNameProps {
  value: string;
  onChange: (next: string) => void;
  disabled?: boolean;
  width?: number;
}

const ManagerSearchByName: React.FC<ManagerSearchByNameProps> = ({
  value,
  onChange,
  disabled,
  width = 280,
}) => {
  return (
    <Input.Search
      placeholder="Search by Name"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      prefix={<SearchOutlined />}
      allowClear
      disabled={disabled}
      style={{ width }}
    />
  );
};

export default ManagerSearchByName;